import { Injectable } from '@angular/core';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanningService {

  constructor() { }

  textToSearch: string = '';
  bookingsDataAll: any = [];
  bookingsData: any = [];

  rangeDates: Date[] | null = null;
  selectedOffice: string[] = [];
  selectedService: string[] = [];
  selectedCapacity: any[] = [];

  counter: number = 0;

  filteredPlanningData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);


  get filteredPlanningDataGet(){
    return this.filteredPlanningData.asObservable();
  }

  set filteredPlanningDataSet(data: any){
    this.filteredPlanningData.next(data);
  }

  ngOnInit(){
    this.filteredPlanningDataGet.subscribe((bookingServices: any) => {
      this.bookingsData = bookingServices;
    });
  }

  filterPlanningResult(text?: string){

    if(text){
      this.textToSearch = text;
    }
    
    // filtro texto global
    let filteredPlanningDataAux = this.bookingsData.filter( (bookingsData: any) => {
      let date: any = '';
      const parsedDate = parse(bookingsData?.date, 'dd-MM-yyyy', new Date());

      if (isNaN(parsedDate.getTime())) {
        date = '';
      }else{
        date = format(parsedDate, 'EEEE dd/MM/yyyy', { locale: es });
      }

      return bookingsData?.booking.reference.toLowerCase().includes(this.textToSearch.toLowerCase())
      || date.toLowerCase().includes(this.textToSearch.toLowerCase())
      || bookingsData?.booking?.customer?.name.toLowerCase().includes(this.textToSearch.toLowerCase())
      || bookingsData?.hour.toLowerCase().includes(this.textToSearch.toLowerCase())
      || bookingsData?.service_profile?.name.toLowerCase().includes(this.textToSearch.toLowerCase());
    });

    // filtro fechas
    if(this.rangeDates != null && this.rangeDates[1] != null){

      filteredPlanningDataAux = filteredPlanningDataAux.filter((bookingService: any) => {
        // const createdAtDate = new Date(bookingService.date);
        const createdAtDate = parse(bookingService.date, 'dd-MM-yyyy', new Date());
        if(this.rangeDates != null){
          return createdAtDate >= this.rangeDates[0] && createdAtDate <= this.rangeDates[1];
        }else{
          return false;
        }
      });
    }

    if(this.selectedOffice.length > 0){
      let officesIds: any = [];
      officesIds = this.selectedOffice.map((office: any) => office.id);
      filteredPlanningDataAux = filteredPlanningDataAux.filter((bookingService: any) => {
          return officesIds.includes(bookingService.booking.office_id);
      });
    }

    if(this.selectedService.length > 0){
      let servicesIds: any = [];
      servicesIds = this.selectedService.map((service: any) => service.id);
      filteredPlanningDataAux = filteredPlanningDataAux.filter((bookingService: any) => {
          return servicesIds.includes(bookingService.service_profile?.service_id);
      });
    }
    if(this.selectedCapacity.length > 0){
      filteredPlanningDataAux = filteredPlanningDataAux.filter((bookingService: any) => {
        let capacityFlag: boolean = false;
        this.selectedCapacity.forEach((capacity: any, index: number) => {
          if(capacity.value == bookingService.units){
            capacityFlag = true;
          }
            return;
        });
        return capacityFlag;
      });
    }
    
    this.filteredPlanningDataSet = filteredPlanningDataAux;
   

  }
  
//filtrar array de ids para validar que existe dentro del array de objetos
//   // Supongamos que tienes un array de IDs y un array de objetos
// const arrayIds = [1, 3, 7, 2, 33];

// const arrayObjetos = [
//   { id: 1, nombre: 'Objeto 1' },
//   { id: 2, nombre: 'Objeto 2' },
//   { id: 3, nombre: 'Objeto 3' },
//   { id: 4, nombre: 'Objeto 4' },
//   { id: 5, nombre: 'Objeto 5' }
// ];

// // Filtrar los objetos cuyos IDs están presentes en arrayIds
// const objetosFiltrados = arrayObjetos.filter(objeto => arrayIds.includes(objeto.id));
// console.log('Objetos filtrados:', objetosFiltrados);



}
